import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { MapPin, ChevronRight } from 'lucide-react';
import { onMarketsSnapshot, onActiveMarketIdsSnapshot } from '@paulownia/shared/services/markets';
import { DAY_OF_WEEK_LABELS, type Market } from '@paulownia/shared/types';

export function MarketSearchSection() {
  const navigate = useNavigate();
  const [markets, setMarkets] = useState<Market[]>([]);
  const [activeMarketIds, setActiveMarketIds] = useState<Set<string> | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribeMarkets = onMarketsSnapshot((data) => {
      setMarkets(data);
    }, true);

    const unsubscribeIds = onActiveMarketIdsSnapshot((ids) => {
      setActiveMarketIds(ids);
    });

    return () => {
      unsubscribeMarkets();
      unsubscribeIds();
    };
  }, []);

  useEffect(() => {
    if (markets.length >= 0 && activeMarketIds !== null) {
      setLoading(false);
    }
  }, [markets, activeMarketIds]);

  const filteredMarkets = activeMarketIds
    ? markets.filter((m) => activeMarketIds.has(m.id))
    : [];

  if (loading) {
    return null;
  }

  if (filteredMarkets.length === 0) {
    return null;
  }

  return (
    <div className="bg-white rounded-xl shadow-md p-4 space-y-3">
      <h2 className="text-lg font-semibold text-gray-900 flex items-center gap-2">
        <MapPin className="w-5 h-5 text-orange-600" />
        Trouver un commerçant par marché
      </h2>
      <div className="space-y-2">
        {filteredMarkets.map((market) => (
          <button
            key={market.id}
            onClick={() => navigate(`/market/${market.id}`)}
            className="w-full flex items-center justify-between p-3 bg-gray-50 hover:bg-orange-50 rounded-lg transition-colors text-left group"
          >
            <div>
              <p className="font-medium text-gray-900 group-hover:text-orange-700">
                {market.city}
              </p>
              <p className="text-sm text-gray-500">
                {DAY_OF_WEEK_LABELS[market.dayOfWeek]} · {market.openingTime} – {market.closingTime}
              </p>
            </div>
            <ChevronRight className="w-4 h-4 text-gray-400 group-hover:text-orange-600 flex-shrink-0" />
          </button>
        ))}
      </div>
    </div>
  );
}
